import * as _ from "lodash";

export class Brand {
    // Change the hashtags here and in infoPanel.tsx
    static Hashtag1     = new Brand("1", "rgb(0, 121, 193)",  "#PyeongChang2018");
    static Hashtag2     = new Brand("2", "rgb(249, 179, 31)", "TorchRelay");
    static Hashtag3     = new Brand("3", "rgb(0, 150, 63)",   "IOC & Technology");
    static Hashtag4     = new Brand("4", "rgb(230, 28, 68)",  "#AtosTeam");
    static AllBrands    = [Brand.Hashtag1, Brand.Hashtag2, Brand.Hashtag3, Brand.Hashtag4];

    static brandWithName(name: string): Brand {
        return _.find(Brand.AllBrands, it => it.name == name) || new Brand(name, "magenta", name);
    }

    private constructor(public name: string, public color: string, public displayName: string) {
    }

    get iconPath(): string {
        return `assets/app/images/icon-${this.name}.png`;
    }

    get buttonPath(): string {
        return `assets/app/images/button-${this.name}_highlight.png`;
    }

    get deselectedButtonPath(): string {
        return `assets/app/images/button-${this.name}.png`;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/model/brand.ts